import { render, staticRenderFns } from "./statusParams.vue?vue&type=template&id=b91b1b22&"
import script from "./statusParams.vue?vue&type=script&lang=js&"
export * from "./statusParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports